<section class="hero-layout" aria-label="מבצעים והמלצות">

  <!-- ═══════════════════════ MAIN SLIDER ═══════════════════════ -->
  <div class="hero-slider" [class.is-loaded]="carouselSlider?.length">

    <swiper-container class="h-100" [sale4AllSwiper]="swiperConfig" init="false" dir="rtl"
      data-testid="homepage-hero-carousel">
      @for (slide of carouselSlider; track slide; let i = $index) {
        <swiper-slide>
          <div
            class="slide-item"
            [style.background-image]="'url(' + serverUrl + slide.image + ')'"
            [attr.aria-label]="'Slide ' + (i + 1)"
            role="img">
            <div class="slide-overlay"></div>
          </div>
        </swiper-slide>
      }
      @if (!carouselSlider?.length) {
        <swiper-slide aria-label="הקרוסלה נטענת">
          <div class="skeleton-block"></div>
        </swiper-slide>
      }

      <div class="swiper-pagination slider-pagination"></div>

      <button
        mat-icon-button
        class="slider-nav slider-nav--prev"
        aria-label="Previous slide">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        class="slider-nav slider-nav--next"
        aria-label="Next slide">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </swiper-container>

  </div>

  <!-- Commercial placements remain available, but sit beneath the main
  campaign so they do not compete with the first-screen message. -->
  <aside class="side-panel" aria-label="תוכן ממומן">
    <div class="side-card side-card--top">
      <app-advertisement [advertisementType]="AdvertisementEnum.SQUARE"></app-advertisement>
    </div>
    <div class="side-card side-card--bottom">
      <app-advertisement [advertisementType]="AdvertisementEnum.SQUARE"></app-advertisement>
    </div>
  </aside>

</section>

<!-- ═══════════════════════ TRENDS ═══════════════════════ -->
<!-- Lives here rather than in the home page template because the jobs
circles below are rendered inside this component — placing it in the
parent could only ever put it above or below the whole slider block,
never between the hero and the jobs rail. -->
<a class="trends-banner" routerLink="/trends" dir="rtl">
  <span class="trends-banner__ico" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 17l6-6 4 4 7-7"/><path d="M14 8h6v6"/>
    </svg>
  </span>
  <span class="trends-banner__text">
    <span class="trends-banner__title">טרנדים</span>
    <span class="trends-banner__sub">ראה מה חם עכשיו בשוק</span>
  </span>
  <span class="trends-banner__cta">לכניסה ←</span>
</a>

<!-- ═══════════════════════ JOB CIRCLES BANNER ═══════════════════════ -->
<div class="job-circles-wrapper">
  <app-job-circles-banner></app-job-circles-banner>
</div>

<!-- ═══════════════════════ EXTENDED BOTTOM BANNER ═══════════════════════ -->
<!-- Stays display:none (not *ngIf) until we know there's an ad — *ngIf would
unmount app-advertisement before it ever gets the chance to fetch and
tell us whether one exists. Once adReady says "no ad", it just stays
hidden instead of showing this wrapper's margin/min-height as a gap. -->
<div class="extended-banner" [class.is-hidden]="!hasExtendBanner">
  <app-advertisement
    [advertisementType]="AdvertisementEnum.EXTEND_BANNER"
    (adReady)="onExtendBannerReady($event)"
  ></app-advertisement>
</div>
